export const EXCLUDED_SUBDOMAINS = ['rusin-stage', 'uat', 'my', 'localhost'];
